(() => {
  function init(root = document) {
    root.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.emDotsReady) return;
      const group = gallery.querySelector('.em-gallery-dots');
      const slides = gallery.querySelector('[id^="Slider-Gallery-"]');
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      if (!group || !slides || !viewer) return;
      gallery.dataset.emDotsReady = '1';
      const buttons = [...group.querySelectorAll('button')];
      const mark = (active) => {
        if (!active) return;
        buttons.forEach((button) => button.setAttribute('aria-current', String(button.dataset.emMediaId === active.dataset.mediaId)));
      };
      const markVisible = () => {
        const left = slides.getBoundingClientRect().left;
        const visible = [...slides.children].filter((slide) => slide.clientWidth > 0);
        const nearest = visible.reduce((best, slide) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - left);
          return !best || distance < best.distance ? { slide, distance } : best;
        }, null);
        mark(nearest?.slide);
      };
      buttons.forEach((button) => button.addEventListener('click', () => gallery.setActiveMedia(button.dataset.emMediaId, false)));
      viewer.addEventListener('slideChanged', (event) => mark(event.detail?.currentElement));
      let frame;
      slides.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(markVisible);
      }, { passive: true });
      new ResizeObserver(markVisible).observe(slides);
      markVisible();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
